// extracted by css-extract-rspack-plugin
export default {"cls1":"NewsInteractionBar-cls1_Eiq","cls2":"NewsInteractionBar-cls2_ETt NewsInteractionBar-cls1_Eiq"};